/**
 * lucide-react v0.274.0 - ISC
 */

import createLucideIcon from '../createLucideIcon.js';

const Check = createLucideIcon("Check", [
  ["polyline", { points: "20 6 9 17 4 12", key: "10jjfj" }]
]);

export { Check as default };
//# sourceMappingURL=check.js.map
